import {Vue, Component} from 'vue-property-decorator'


/**
 * 팝업의 상태[열림/닫힘]를 제어하기 위한 핸들러 믹스인
 * @mixin
 */
@Component
export default class PopupHandler extends Vue {
  popupStatus: any = {}

  /**
   * 입력된 이름의 팝업을 '열림' 상태로 변경
   * @param name
   */
  openPopup(name: string) {
    this.$set(this.popupStatus, name, true)
  }

  /**
   * 입력된 이름의 팝업을 '닫힘' 상태로 변경
   * @param name
   */
  closePopup(name: string) {
    this.$set(this.popupStatus, name, false)
  }

  /**
   * 입력된 이름의 팝업을 전달 받은 상태로 변경
   * @param name
   * @param status
   */
  setPopupStatus(name: string, status: boolean) {
    this.$set(this.popupStatus, name, status)
  }

  /**
   * 입력된 이름의 팝업의 상태를 반전
   * @param name
   */
  togglePopup(name: string) {
    this.$set(this.popupStatus, name, !this.popupStatus[name])
  }
}
